<template>
  <div class="kept-items-toggle"
       :class="{ 'kept-items-toggle--guest': !isLoggedIn }"
       v-if="!isLoggedIn || isActive || hasKeptItems">
    <div class="kept-items-toggle__label"
         :role="isLoggedIn ? null : 'button'"
         :tabindex="isLoggedIn ? null : 0"
         :aria-label="isLoggedIn ? null : $translate('Bigtex5::Template.keptItemsGuestTeaserAria')"
         @click="onLabelClick"
         @keydown.enter.prevent="onLabelClick"
         @keydown.space.prevent="onLabelClick">
      <span class="kept-items-toggle__header">
        <button type="button"
                class="kept-items-toggle__info"
                @click.stop="openSizeAssistant"
                :aria-label="$translate('Bigtex5::Template.keptItemsInfoTitle')">
          <i class="fa fa-info-circle"></i>
        </button>
        <span class="kept-items-toggle__title">
          {{ $translate('Bigtex5::Template.keptItemsToggleTitle') }}
        </span>
        <span class="kept-items-toggle__badge">
          {{ $translate('Bigtex5::Template.keptItemsToggleBadge') }}
        </span>
        <i v-if="!isLoggedIn"
           class="fa fa-lock kept-items-toggle__lock"
           :title="$translate('Bigtex5::Template.keptItemsGuestTeaserAria')"></i>
      </span>
      <label class="kept-items-toggle__switch">
        <input type="checkbox"
               class="kept-items-toggle__checkbox"
               :checked="isActive"
               :disabled="!isLoggedIn"
               @change="toggleFilter">
        <span class="kept-items-toggle__slider"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isLoggedIn() {
      return this.$store.state.user.userData !== null && this.$store.state.user.userData.id > 0;
    },
    hasKeptItems() {
      if (App.keptItems && Object.keys(App.keptItems).length > 0) {
        return true;
      }

      // Auch wenn in dieser Kategorie nichts Gekauftes mehr lieferbar ist, muss
      // der Schalter erreichbar bleiben - sonst kommt der Kunde nie an den
      // Hinweis, dass der Filter seine Artikel sehr wohl kennt.
      return (App.keptItemsUnavailable && App.keptItemsUnavailable.count > 0) || false;
    },
    isActive() {
      if (typeof window === 'undefined') {
        return false;
      }

      const params = new URLSearchParams(window.location.search);
      return params.get('nur_gekauft') === '1';
    }
  },

  methods: {
    // Erklaerung, Vorteile und Registrierung stecken alle im Groessen-Assistenten
    // (CustomerPropModal.vue aus dem PageDesign) - hier wird er nur angefordert.
    openSizeAssistant() {
      window.bigtexSizeAssistantPending = true;
      $(document).trigger('bigtex:size-assistant');
    },

    // Gaeste sehen den Toggle ausgegraut: jeder Klick darauf erklaert stattdessen,
    // was die Registrierung bringt.
    onLabelClick() {
      if (this.isLoggedIn) {
        return;
      }

      this.openSizeAssistant();
    },

    toggleFilter() {
      if (!this.isLoggedIn) {
        return;
      }

      const url = new URL(window.location.href);

      if (this.isActive) {
        url.searchParams.delete('nur_gekauft');
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('nur_gekauft', '1');
        url.searchParams.delete('page');
        // Exklusiv zu den BeastSearch-Filtern: der Kept-Filter ignoriert sie
        // serverseitig ohnehin, also beim Aktivieren aus der URL entfernen.
        [...url.searchParams.keys()]
          .filter(key => key === 'bsf' || key.startsWith('bsf['))
          .forEach(key => url.searchParams.delete(key));
      }

      window.location.href = url.toString();
    }
  }
};
</script>
